module.exports = __webpack_public_path__ + "img/stripes-bg.69f85f37.svg";